import { z } from 'zod';
import { DefaultView } from '../../../../utils/userSettings';

export const defaultUserSettingsSchema = z.object({
  defaultSchemaId: z.string().min(1, 'Schema is required'),
  defaultView: z.nativeEnum(DefaultView),
});

export type IDefaultUserSettingsState = z.infer<
  typeof defaultUserSettingsSchema
>;
